<template>
  <div>
    <div class="login login2" v-if="isRegistered == '1'">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="" />
            <span class="register">注册</span>
          </div>
          <div class="rightBox">
            <span class="loginText" @click="registered">登录</span>
            <span class="brackIndex" @click="goToIndex">返回首页</span>
          </div>
        </div>
      </div>

      <div class="registerCent registerCent2">
        <div class="loginBox warp">
          <div class="loginForm">
            <div class="loginTit">
              <div class="step steped">
                <span class="number">1</span>
                <span class="text">验证手机号</span>
              </div>
              <div :class="line2"></div>
              <div :class="class2">
                <span class="number">2</span>
                <span class="text">设置密码</span>
              </div>
              <div :class="line3"></div>
              <div :class="class3">
                <span class="number">3</span>
                <span class="text">注册成功</span>
              </div>
            </div>
            <a-spin :spinning="spinning">
              <div class="loginFormBox" v-if="registerConfirm == false">
                <el-form
                  :model="register"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="120px"
                  class="demo-ruleForm"
                >
                  <el-form-item label="手机号" prop="phone">
                    <div class="inputBox">
                      <el-input
                        v-model="register.phone"
                        type="text"
                        auto-complete="off"
                        placeholder="请输入手机号"
                        class="iptHeight"
                      >
                      </el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="图形验证码" prop="imgcode">
                    <div class="inputBox">
                      <el-input
                        v-model="register.imgcode"
                        type="text"
                        auto-complete="off"
                        placeholder="请输入图形验证码"
                        class="iptHeight"
                      >
                      </el-input>
                      <span class="codeBtn"
                    ><img class="logincode" :src="codeUrl" @click="getImgCode"
                  /></span>
                    </div>
                  </el-form-item>
                  <!-- <div class="inputBox">
                  <label>手机号</label>
                  <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input>
                  <el-input
                    v-model="register.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="请输入手机号"
                    class="iptHeight"
                  >
                  </el-input>
                </div> -->
                  <el-form-item label="验证码" prop="code">
                    <div class="inputBox">
                      <el-input
                        v-model="register.code"
                        placeholder="请输入验证码"
                        style="width: 315px"
                      ></el-input>
                      <span
                        v-show="codeShow"
                        class="codeBtn"
                        @click="getCode(register.phone)"
                        >获取验证码</span
                      >
                      <span v-show="!codeShow" class="codeBtn codeCount"
                        >重新获取({{ codeCountNum }}s)</span
                      >
                    </div>
                  </el-form-item>
                  <!-- <div class="inputBox">
                  <label>验证码</label>
                  <el-input
                    v-model="register.code"
                    placeholder="请输入验证码"
                    style="width: 315px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(register.phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div> -->
                  <el-form-item label="用户名" prop="userName">
                    <div class="inputBox">
                      <el-input
                        v-model="register.userName"
                        type="text"
                        auto-complete="off"
                        placeholder="请输入字母或者字母加数字或者纯数字"
                        class="iptHeight"
                      >
                      </el-input>
                    </div>
                  </el-form-item>
                  <!-- <div class="inputBox">
                  <label>用户名</label>
                 
                  <el-input
                    v-model="register.userName"
                    type="text"
                    auto-complete="off"
                    placeholder="请输入4-25位中文或字母和数字组合"
                    class="iptHeight"
                  >
                  </el-input>
                </div> -->
                  <el-form-item label="设置密码" prop="password">
                    <div class="inputBox">
                      <el-input
                        v-model="register.password"
                        type="password"
                        auto-complete="off"
                        placeholder="设置6-22位数字和字母组合"
                        class="iptHeight"
                        @blur="handleblur"
                      >
                      </el-input>
                    </div>
                  </el-form-item>
                  <!-- <div class="inputBox">
                  <label>设置密码</label>
                  
                  <el-input
                    v-model="register.password"
                    type="password"
                    auto-complete="off"
                    placeholder="设置6-22位数字和字母组合"
                    class="iptHeight"
                    @blur="handleblur"
                  >
                  </el-input>
                </div> -->
                  <el-form-item label="确认密码" prop="verify">
                    <div class="inputBox">
                      <el-input
                        v-model="register.verify"
                        type="password"
                        auto-complete="off"
                        placeholder="请再次确认"
                        class="iptHeight"
                      >
                      </el-input>
                    </div>
                  </el-form-item>
                  <!-- <div class="inputBox">
                  <label>确认密码</label>
                  
                  <el-input
                    v-model="register.verify"
                    type="password"
                    auto-complete="off"
                    placeholder="请再次确认"
                    class="iptHeight"
                  >
                  </el-input>
                </div> -->
                </el-form>
                <!-- <div
                class="noLogin"
                :class="{ registered: isRegistered === '1' }"
              >
                <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"
                  >七天免登录</el-checkbox
                >
                <span
                  @click="registered"
                  v-text="isRegistered === '1' ? '登录' : '用户注册'"
                ></span>
              </div> -->
                <div class="loginBtn" @click="Register('ruleForm')">确定</div>
              </div>
              <div class="regSuccess" v-else>
                <div class="icon"><i class="el-icon-success"></i></div>

                <div class="text">恭喜你注册成功!</div>
                <!-- <div class="toLogin" style="text-align:center;">{{count}}</div> -->
                <div class="toLogin" style="text-align: center">
                  <el-button
                    class="fs16 mar-bot-5"
                    type="primary"
                    size="medium"
                    @click="goToIndex"
                    >进入首页</el-button
                  >
                  <el-button
                    class="fs16 mar-bot-5"
                    type="primary"
                    size="medium"
                    @click="goToApprove"
                    >企业认证</el-button
                  >
                </div>
              </div>
            </a-spin>
            <!-- <div class="loginProtocol" v-if="isRegistered === '1'">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span>阅读并同意</span>
              <span @click="readAgreement">《小黄牛供应链注册协议》</span>
            </div> -->
          </div>
        </div>
      </div>

      <div class="footText footText2">
        保山数字产业发展有限责任公司
      </div>
      <!-- <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
        这是服务协议
      </el-dialog> -->
    </div>
    <div class="login login2" v-else-if="isRegistered == '2'">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="" />
          </div>
          <div class="rightBox">
            <span class="loginText" @click="goToIndex">返回首页</span>
          </div>
        </div>
      </div>
      <div class="loginCent loginCent2">
        <div class="loginBox warp">
          <div class="conTitle">
            <span class="bigTitle"></span>
            <span class="smallTitle"></span>
          </div>
          <div class="leftImg">
            <img src="" alt="" />
          </div>
          <div class="loginForm">
            <div
              class="loginTit"
              v-text="isRegistered == '1' ? '' : '欢迎登录小黄牛供应链平台'"
            ></div>
            <div class="loginType">
              <span class="account" @click="changeType" :class="classType1"
                >账号登录</span
              >
              <span class="code" @click="changeType" :class="classType2"
                >验证码登录</span
              >
            </div>
            <a-spin :spinning="spinning">
              <div class="loginFormBox" v-if="loginType == true">
                <div class="inputBox">
                  <!-- <label>手机号码</label> -->
                  <!-- <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input> -->
                  <el-input
                    v-model="username"
                    type="text"
                    maxlength="30"
                    auto-complete="off"
                    placeholder="手机号/用户名"
                    class="iptHeight"
                  >
                    <!-- <svg-icon
                    slot="prefix"
                    icon-class="user"
                    class="el-input__icon input-icon"
                  /> -->
                  </el-input>
                </div>
                <div class="inputBox">
                  <!-- <label>验证码</label> -->
                  <el-input
                    :type="passwordType"
                    v-model="password"
                    placeholder="请输入密码"
                  ></el-input>
                  <!-- <span v-show="codeShow" class="codeBtn" @click="getCode"
                  >获取验证码</span
                >
                <span v-show="!codeShow" class="codeBtn codeCount"
                  >重新获取({{ codeCountNum }}s)</span
                > -->
                  <span class="show-pwd" @click="showPwd">
                    <svg-icon
                      :icon-class="
                        passwordType === 'password' ? 'eye' : 'eye-open'
                      "
                    />
                  </span>
                </div>
                <div class="inputBox" style="margin-bottom: 30px">
                  <!-- <label>验证码</label> -->
                  <el-input
                    v-model="imgVerifyCode"
                    placeholder="请输入验证码"
                    style="width: 280px"
                  ></el-input>
                  <span v class="codeBtn"
                    ><img class="logincode" :src="codeUrl" @click="getImgCode"
                  /></span>
                </div>

                <div
                  class="loginBtn"
                  @click="getLoginPwd"
                  v-text="isRegistered === '1' ? '注册' : '立即登录'"
                >
                  立即登录
                </div>
              </div>
              <div class="loginFormBox" v-else>
                <div class="inputBox">
                  <!-- <label>手机号码</label> -->
                  <!-- <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input> -->
                  <el-input
                    v-model="phone"
                    type="text"
                    maxlength="30"
                    auto-complete="off"
                    placeholder="手机号"
                    class="iptHeight"
                  >
                    <!-- <svg-icon
                    slot="prefix"
                    icon-class="user"
                    class="el-input__icon input-icon"
                  /> -->
                  </el-input>
                </div>
                <div class="inputBox">
                  <!-- <label>验证码</label> -->
                  <el-input
                    v-model="imgVerifyCode"
                    placeholder="请输入图形验证码"
                    style="width: 280px"
                  ></el-input>
                  <span v class="codeBtn"
                    ><img class="logincode" :src="codeUrl" @click="getImgCode"
                  /></span>
                </div>
                <div class="inputBox" style="margin-bottom: 30px">
                  <!-- <label>验证码</label> -->
                  <el-input
                    v-model="verificationCode"
                    placeholder="请输入验证码"
                    style="width: 280px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div>

                <div
                  class="loginBtn"
                  @click="login"
                  v-text="isRegistered === '1' ? '注册' : '立即登录'"
                >
                  立即登录
                </div>
              </div>
            </a-spin>
            <div class="noLogin" :class="{ registered: isRegistered === '1' }">
              <!-- <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"
                  >七天免登录</el-checkbox
                > -->
              <!-- <span
                @click="forgetPassword"
                v-text="isRegistered === '1' ? '' : '忘记密码?'"
              ></span>
              <span
                @click="forgetUsername"
                v-text="isRegistered === '1' ? '' : '忘记用户名?'"
              ></span> -->
              <span
                @click="registered"
                v-text="isRegistered === '1' ? '' : '用户注册'"
              ></span>
            </div>
            <!-- <div class="loginProtocol" v-if="isRegistered === '1'">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span>阅读并同意</span>
              <span @click="readAgreement">《小黄牛供应链注册协议》</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="footText footText2">
        COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED
        滇ICP备2021004155号
      </div>
      <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
        这是服务协议
      </el-dialog>
    </div>

    <div class="login" v-else-if="isRegistered == '3'">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="" />
            <span class="register">找回密码</span>
          </div>
          <div class="rightBox">
            <span class="loginText" @click="registered2">注册</span>
            <span class="brackIndex" @click="registered">登录</span>
            <span class="brackIndex" @click="goToIndex">返回首页</span>
          </div>
        </div>
      </div>
      <div class="registerCent">
        <div class="loginBox warp">
          <div class="loginForm">
            <div v-if="findPassword == true">
              <div class="findPassword">
                <div class="icon"><i class="el-icon-warning"></i></div>
                <div class="content">
                  <div class="text">请输入你需要找回登录密码的账户名</div>
                </div>
              </div>
              <div class="loginFormBox" v-if="registerConfirm == false">
                <div class="inputBox">
                  <label>登录名</label>
                  <!-- <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input> -->
                  <el-input
                    v-model="findForm.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="手机/用户名"
                    class="iptHeight"
                  >
                  </el-input>
                </div>
                <div class="inputBox">
                  <label>验证码</label>
                  <el-input
                    v-model="findForm.code"
                    placeholder="请输入验证码"
                    style="width: 315px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(findForm.phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div>

                <!-- <div
                class="noLogin"
                :class="{ registered: isRegistered === '1' }"
              >
                <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"
                  >七天免登录</el-checkbox
                >
                <span
                  @click="registered"
                  v-text="isRegistered === '1' ? '登录' : '用户注册'"
                ></span>
              </div> -->
                <div class="loginBtn" @click="Find()">确定</div>
              </div>
              <div class="regSuccess" v-else>
                <div class="icon"><i class="el-icon-success"></i></div>
                <div class="content">
                  <div class="text">恭喜你注册成功!</div>
                  <div class="toLogin" @click="registered">登录</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="loginTit">
                <div class="step steped">
                  <span class="number">1</span>
                  <span class="text">验证身份</span>
                </div>
                <div :class="line2"></div>
                <div :class="class2">
                  <span class="number">2</span>
                  <span class="text">找回密码</span>
                </div>
                <div :class="line3"></div>
                <div :class="class3">
                  <span class="number">3</span>
                  <span class="text">完成</span>
                </div>
              </div>
              <div class="loginFormBox" v-if="findStep == '1'">
                <div class="inputBox">
                  <div class="">
                    <span>手机验证码验证 账户</span>
                    <span class="phone">{{ findForm.phone }}</span>
                    <span>为确认是你本人操作,请完成一下验证</span>
                  </div>
                </div>
                <div class="inputBox">
                  <label>手机号</label>
                  <el-input
                    v-if="nouse == false"
                    v-model="findForm.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="手机/用户名"
                    class="iptHeight"
                  >
                  </el-input>
                  <span class="yesuse" v-else>
                    <span class="phone">{{ findForm.phone }}</span>
                    <span class="alter" @click="Nouse()"
                      >[手机不可用?点此修改]</span
                    >
                  </span>
                </div>
                <div class="inputBox">
                  <label>验证码</label>
                  <el-input
                    v-model="setNew.code"
                    placeholder="请输入验证码"
                    style="width: 280px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(etNew.phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div>

                <div class="loginBtn" @click="FindSet()">确定</div>
                <div class="inputBox">
                  <div class="massage">
                    <p class="title">没收到短信验证码?</p>
                    <p class="item">
                      1.网络通讯异常可能会造成短信丢失,请重新获取或稍后再试。
                    </p>
                    <p class="item">
                      2.请核实手机是否欠费停机，或者屏蔽了系统短信。
                    </p>
                    <p class="item">
                      3.如果手机丢失或停用，请选择其他验证方式。
                    </p>
                    <p class="item">
                      4.您也可以尝试将SIM移动到另一部手机，然后重试。
                    </p>
                  </div>
                </div>
              </div>
              <div class="loginFormBox" v-else-if="findStep == '2'">
                <div class="inputBox">
                  <label style="width: 115px">设置新密码</label>
                  <el-input
                    v-model="setNew.password"
                    type="password"
                    auto-complete="off"
                    placeholder="请设置新密码"
                    class="iptHeight"
                  >
                  </el-input>
                </div>
                <div class="inputBox">
                  <label style="width: 115px">确认新密码</label>
                  <el-input
                    v-model="setNew.verify"
                    type="password"
                    auto-complete="off"
                    placeholder="请再次确认新密码"
                    class="iptHeight"
                  >
                  </el-input>
                </div>

                <div class="loginBtn" @click="FindConfirm()">确定</div>
              </div>
              <div class="regSuccess" v-else>
                <div class="icon"><i class="el-icon-success"></i></div>
                <div class="content">
                  <div class="text">重置成功，请牢记新的登录密码噢~!</div>
                  <div class="toLogin" @click="registered">重新登录</div>
                </div>
              </div>
            </div>

            <!-- <div class="loginProtocol" v-if="isRegistered === '1'">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span>阅读并同意</span>
              <span @click="readAgreement">《小黄牛供应链注册协议》</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="footText">
        COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED
        滇ICP备2021004155号
      </div>
      <!-- <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
        这是服务协议
      </el-dialog> -->
    </div>

    <div class="login" v-else>
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="" />
            <span class="register">找回用户名</span>
          </div>
          <div class="rightBox">
            <span class="loginText" @click="registered2">注册</span>
            <span class="brackIndex" @click="registered">登录</span>
            <span class="brackIndex" @click="goToIndex">返回首页</span>
          </div>
        </div>
      </div>
      <div class="registerCent">
        <div class="loginBox warp">
          <div class="loginForm">
            <div v-if="findPassword == true">
              <div class="findPassword">
                <div class="icon"><i class="el-icon-warning"></i></div>
                <div class="content">
                  <div class="text">
                    请输入你的身份证号和真姓名用于找回账户会员名（暂支持已完成注册认证的用户）
                  </div>
                </div>
              </div>
              <div class="loginFormBox" v-if="registerConfirm == false">
                <div class="inputBox">
                  <label>登录名</label>
                  <!-- <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input> -->
                  <el-input
                    v-model="findForm.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="手机/用户名"
                    class="iptHeight"
                  >
                  </el-input>
                </div>
                <div class="inputBox">
                  <label>验证码</label>
                  <el-input
                    v-model="findForm.code"
                    placeholder="请输入验证码"
                    style="width: 280px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(findForm.phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div>

                <!-- <div
                class="noLogin"
                :class="{ registered: isRegistered === '1' }"
              >
                <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"
                  >七天免登录</el-checkbox
                >
                <span
                  @click="registered"
                  v-text="isRegistered === '1' ? '登录' : '用户注册'"
                ></span>
              </div> -->
                <div class="loginBtn" @click="Find()">确定</div>
              </div>
              <div class="regSuccess" v-else>
                <div class="icon"><i class="el-icon-success"></i></div>
                <div class="content">
                  <div class="text">恭喜你注册成功!</div>
                  <div class="toLogin" @click="registered">登录</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="loginTit">
                <div class="step steped">
                  <span class="number">1</span>
                  <span class="text">验证身份</span>
                </div>
                <div :class="line2"></div>
                <div :class="class2">
                  <span class="number">2</span>
                  <span class="text">找回密码</span>
                </div>
                <div :class="line3"></div>
                <div :class="class3">
                  <span class="number">3</span>
                  <span class="text">完成</span>
                </div>
              </div>
              <div class="loginFormBox" v-if="findStep == '1'">
                <div class="inputBox">
                  <div class="">
                    <span>手机验证码验证 账户</span>
                    <span class="phone">{{ findForm.phone }}</span>
                    <span>为确认是你本人操作,请完成一下验证</span>
                  </div>
                </div>
                <div class="inputBox">
                  <label>手机号</label>
                  <el-input
                    v-if="nouse == false"
                    v-model="findForm.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="手机/用户名"
                    class="iptHeight"
                  >
                  </el-input>
                  <span class="yesuse" v-else>
                    <span class="phone">{{ findForm.phone }}</span>
                    <span class="alter" @click="Nouse()"
                      >[手机不可用?点此修改]</span
                    >
                  </span>
                </div>
                <div class="inputBox">
                  <label>验证码</label>
                  <el-input
                    v-model="setNew.code"
                    placeholder="请输入验证码"
                    style="width: 280px"
                  ></el-input>
                  <span
                    v-show="codeShow"
                    class="codeBtn"
                    @click="getCode(setNew.phone)"
                    >获取验证码</span
                  >
                  <span v-show="!codeShow" class="codeBtn codeCount"
                    >重新获取({{ codeCountNum }}s)</span
                  >
                </div>

                <div class="loginBtn" @click="FindSet()">确定</div>
                <div class="inputBox">
                  <div class="massage">
                    <p class="title">没收到短信验证码?</p>
                    <p class="item">
                      1.网络通讯异常可能会造成短信丢失,请重新获取或稍后再试。
                    </p>
                    <p class="item">
                      2.请核实手机是否欠费停机，或者屏蔽了系统短信。
                    </p>
                    <p class="item">
                      3.如果手机丢失或停用，请选择其他验证方式。
                    </p>
                    <p class="item">
                      4.您也可以尝试将SIM移动到另一部手机，然后重试。
                    </p>
                  </div>
                </div>
              </div>
              <div class="loginFormBox" v-else-if="findStep == '2'">
                <div class="inputBox">
                  <label style="width: 115px">设置新密码</label>
                  <el-input
                    v-model="setNew.password"
                    type="password"
                    auto-complete="off"
                    placeholder="请设置新密码"
                    class="iptHeight"
                  >
                  </el-input>
                </div>
                <div class="inputBox">
                  <label style="width: 115px">确认新密码</label>
                  <el-input
                    v-model="setNew.verify"
                    type="password"
                    auto-complete="off"
                    placeholder="请再次确认新密码"
                    class="iptHeight"
                  >
                  </el-input>
                </div>

                <div class="loginBtn" @click="FindConfirm()">确定</div>
              </div>
              <div class="regSuccess" v-else>
                <div class="icon"><i class="el-icon-success"></i></div>
                <div class="content">
                  <div class="text">重置成功，请牢记新的登录密码噢~!</div>
                  <div class="toLogin" @click="registered">重新登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footText">
        COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED
        滇ICP备2021004155号
      </div>
      <!-- <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
        这是服务协议
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import api from "../../api";
import { getCodeImg } from "../../api/imgCode";
import request from "@/config/mixin/server";
import { listSearchMixin } from "../../config/mixin";
import { mapMutations } from "vuex";
export default {
  name: "login",
  mixins: [listSearchMixin],
  data() {
    var validatePhone = (rule, value, callback) => {
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      let regPwd = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
      let reg2 = /^[a-zA-Z]/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    };
    var validateUserName = (rule, value, callback) => {
      let reg = /^/;
      // let regPwd = /^[A-Za-z].*[0-9]|[0-9].*[A-Za-z]|[\u4e00-\u9fa5]/;
      let regPwd = /^[A-Za-z0-9]+$/;
      if (value === "") {
        callback(new Error("请输入用户名"));
      }
      //  else if (value.length < 4 || value.length > 25) {
      //   callback(new Error("用户名需要在4-22位"));
      // } 
      else if (!regPwd.test(value)) {
        callback(new Error("请输入字母或者字母加数字或者纯数字，不能输入中文和符号"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      let regPwd = /^[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
      let reg2 = /^[a-zA-Z]/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 22) {
        callback(new Error("密码长度必须设置6-22位数字和字母组合"));
      } else if (!regPwd.test(value)) {
        callback(new Error("请输入包含字母和数字的组合但不包含特殊字符的密码"));
      } else {
        callback();
      }
    };
    var validateVerify = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        callback();
      }
    };
    return {
      count: 5,
      spinning: false,
      imgcode: "",
      codeUrl: "",
      phone: "",
      username: "",
      password: "",
      imgVerifyCode: "",
      verificationCode: "",
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: "",
      dialogAgreement: false,
      isRegistered: "2",
      loginType: true,
      classType1: "selected",
      classType2: "noselect",
      active: 1,
      registerConfirm: false,
      findPassword: true, //找回密码步骤控制
      findName: true, //找回密码步骤控制
      register: {
        phone: "",
        code: "",
        userName: "",
        password: "",
        verify: "",
        imgcode: "",
      },
      rules: {
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        imgcode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        userName: [
          { required: true, validator: validateUserName, trigger: ["change", "blur" ]},
        ],
        password: [
          { required: true, validator: validatePassword, trigger: ["change", "blur" ] },
        ],
        verify: [
          { required: true, validator: validateVerify, trigger: ["change", "blur" ]},
        ],
      },
      line2: "line",
      class2: "step",
      line3: "line",
      class3: "step",
      findForm: {
        phone: "",
        code: "",
      },
      findStep: "1",
      findStep2: "1",
      nouse: true,
      setNew: {
        code: "",
        password: "",
        verify: "",
      },
      passwordType: "password",
      buyerUserId: "",
    };
  },
  mounted() {
    this.getImgCode();
    if (this.$route.query.type) {
      this.isRegistered = this.$route.query.type;
    }
  },
  watch: {
    count: function (newVal, oldVal) {
      if (newVal == 0) {
        this.$router.push("/");
        return;
      }
    },
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
      setName: "SET_NAME", // 修改用户信息
    }),

    countDown() {
      this.count--;
    },
    //显示密码
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    changeType() {
      this.loginType = !this.loginType;
      if (this.loginType == true) {
        this.classType1 = "selected";
        this.classType2 = "noselect";
      } else {
        this.classType1 = "noselect";
        this.classType2 = "selected";
      }
    },
    getImgCode() {
      let self = this;

      getCodeImg().then((res) => {
        console.log(res);
        this.imgcode = res.data.msg;
        let blob = res.data.data.captcha;
        console.log(blob);
        self.codeUrl = blob;
        Cookie.set("code", res.data.msg);
      });
    },
    getUserInfo(buyerUserId) {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.setUserInfo(res.data);

          self.userInfoData = JSON.parse(JSON.stringify(res.data));
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // getUserInfo() {
    //   let self = this;
    //   let params = {
    //     url: api.getUser,
    //     method: "GET",
    //   };
    //   self.sendReq(params, (res) => {
    //     if (res.code === "200") {

    //       let data = res.data
    //       self.setUserInfo(data);
    //       self.setName(Cookie.get("account"));
    //       self.userInfoData = data;
    //       self.userInfoData.account = Cookie.get("account");
    //       // console.log(res)
    //     }
    //   });
    // },
    getCode(phone) {
      const TIME_COUNT = 120;
      let self = this;
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      if (phone == "") {
        self.$message.error("请输入手机号");
        return;
      }

      if (!reg.test(phone)) {
        self.$message.error("手机号格式错误");
        return;
      }
      if(self.isRegistered == '1'){
        if (self.register.imgcode == "") {
          self.$message({
            message: "请输入图形验证码",
            type: "error",
          });
          return;
        }
        
      }else{
        if (self.imgVerifyCode == "") {
          self.$message({
            message: "请输入图形验证码",
            type: "error",
          });
          return;
        }
    }
      
      let params = {
        url: api.vCode,
        method: "POST",
        data: {
          mobile: phone,
          code: self.imgcode,
          imgVerifyCode: self.register.imgcode || self.imgVerifyCode 
        },
        handleError: true  // 添加这个参数，告诉拦截器不要统一处理错误
      };
      
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          if (!this.timer) {
            this.codeCountNum = TIME_COUNT;
            this.codeShow = false;
            this.timer = setInterval(() => {
              if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
                this.codeCountNum--;
              } else {
                this.codeShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$message.success("验证码获取成功");
        } else {
          // 发生错误时重置倒计时状态
          this.codeShow = true;
          clearInterval(this.timer);
          this.timer = null;
          // 显示错误信息
          this.$message.error(res.message || res.msg || "获取验证码失败");
        }
      }).catch(error => {
        // 处理请求失败的情况
        this.codeShow = true;
        clearInterval(this.timer);
        this.timer = null;
        this.$message.error(error.message || "获取验证码失败，请稍后重试");
      });
    },
    // 阅读协议
    readAgreement() {
      this.dialogAgreement = true;
    },
    //跳转首页
    goToIndex() {
      this.$router.push({ path: "/" });
    },
    //跳转企业认证
    goToApprove() {
      this.$router.push({ path: "/companyCertificate" });
    },
    Register(ruleForm) {

      let self = this;
       this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            if (self.register.password != self.register.verify) {
        self.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return;
      }
      self.spinning = true;
      let params = {
        url: api.register,
        method: "POST",
        data: {
          phone: self.register.phone,
          verificationCode: self.register.code,
          account: self.register.userName,
          pwd: self.register.password,
          confirm: self.register.verify,
          type: Number(self.isRegistered),
          imgVerifyCode: "",
        },
      };
      self.sendReq(params, (res) => {
        console.log(res);
        self.spinning = false;
        if (res.code === "200") {
          Cookie.set("account", res.data.account);
          this.registerConfirm = true;
          this.line3 = "line lined";
          this.class3 = "step steped";
          // this.count = 5;
          // setInterval(this.countDown,1000);
          console.log(res.data.token);
          Cookie.set("token", res.data.token);
          let buyerUserId = res.data.buyerUserId;
          res.data.name = res.data.account
          self.setUserInfo(res.data);
          self.setName(Cookie.get("account"));
          self.userInfoData = res.data;
          self.userInfoData.account = Cookie.get("account");
          this.getUserInfo(buyerUserId);

          this.$message.success("注册成功");
          // this.$router.push({ path: "/" });
        } else {
          this.$message.warning(res.message);
        }
      });

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      
      
    },
    login() {
      let self = this;
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      if (self.phone == "") {
        self.$message({
          message: "请输入手机号",
          type: "error",
        });
        return;
      }
      if (!reg.test(self.phone)) {
        self.$message({
          message: "手机号码格式错误",
          type: "error",
        });
        return;
      }
      if (self.imgVerifyCode === "") {
        self.$message({
          message: "请输入图形验证码",
          type: "error",
        });
        return;
      }
      if (self.verificationCode === "") {
        self.$message({
          message: "请输入验证码",
          type: "error",
        });
        return;
      }
      if (self.isRegistered === "2") {
        this.getLogin();
      } else if (this.haveRead) {
        this.getLogin();
      } else {
        this.$message.warning("请阅读并同意服务协议");
      }
    },
    getLoginPwd() {
      let self = this;
      if (self.username === "") {
        self.$message({
          message: "请输入手机号/用户名",
          type: "error",
        });
        return;
      }
      // let reg = /^1[13456789]\d{9}$/;

      // if (!reg.test(self.username)) {
      //   self.$message({
      //     message: "手机号码格式错误",
      //     type: "error",
      //   });
      //   return;
      // }
      if (self.password === "") {
        self.$message({
          message: "请输入密码",
          type: "error",
        });
        return;
      }
      if (self.imgVerifyCode === "") {
        self.$message({
          message: "请输入图形验证码",
          type: "error",
        });
        return;
      }
      let params = {
        url: api.loginPwd,
        method: "POST",
        data: {
          phone: "",
          account: self.username,
          username: "",
          pwd: self.password,
          imgVerifyCode: self.imgVerifyCode,
        },
      };
      this.spinning = true;
      self.sendReq(params, (res) => {
        this.spinning = false;
        if (res.code === "200") {
          Cookie.set("account", res.data.account);
          if (self.isNoLogin) {
            Cookie.set("token", res.data.token, { expires: 7 });
          } else {
            Cookie.set("token", res.data.token, { expires: 1 });
          }
          let buyerUserId = res.data.buyerUserId;
          self.setUserInfo(res.data);
          self.setName(Cookie.get("account"));
          self.userInfoData = res.data;
          self.userInfoData.account = Cookie.get("account");
          this.getUserInfo(buyerUserId);
          this.$message.success("登录成功");
          let platform = localStorage.getItem("platform");
          if(platform == "b2c"){
            this.$router.push({ path: "/shop_mall/index" });
          }else{
            this.$router.push({ path: "/" });
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    getLogin() {
      let self = this;
      let params = {
        url: api.login,
        method: "POST",
        data: {
          phone: self.phone,
          verificationCode: self.verificationCode,
          type: self.isRegistered,
        },
      };
      this.spinning = true;
      self.sendReq(params, (res) => {
        // console.log(res)
        this.spinning = false;
        if (res.code === "200") {
          Cookie.set("account", res.data.account);
          if (self.isNoLogin) {
            Cookie.set("token", res.data.token, { expires: 7 });
          } else {
            Cookie.set("token", res.data.token, { expires: 1 });
          }
          let buyerUserId = res.data.buyerUserId;
          self.setUserInfo(res.data);
          self.setName(Cookie.get("account"));
          self.userInfoData = res.data;
          self.userInfoData.account = Cookie.get("account");
          this.getUserInfo(buyerUserId);
          this.$message.success("登录成功");
          let platform = localStorage.getItem("platform");
          if(platform == "b2c"){
            this.$router.push({ path: "/shop_mall/index" });
          }else{
            this.$router.push({ path: "/" });
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    forgetPassword() {
      this.isRegistered = "3";
    },

    forgetUsername() {
      this.isRegistered = "4";
    },
    registered2() {
      this.line2 = "line";
      this.class2 = "step";
      this.line3 = "line";
      this.class3 = "step";
      this.registerConfirm = false;
      this.findPassword = true;
      this.findStep = "1";
      this.codeShow = true;
      clearInterval(this.timer);
      this.timer = null;
      this.userName = "";
      this.verificationCode = "";

      if (this.isRegistered === "3" || this.isRegistered === "4") {
        this.isRegistered = "1";
      }
    },
    registered() {
      this.line2 = "line";
      this.class2 = "step";
      this.line3 = "line";
      this.class3 = "step";
      this.registerConfirm = false;
      this.findPassword = true;
      this.findStep = "1";
      this.codeShow = true;
      clearInterval(this.timer);
      this.timer = null;
      this.userName = "";
      this.verificationCode = "";

      if (
        this.isRegistered === "1" ||
        this.isRegistered === "3" ||
        this.isRegistered === "4"
      ) {
        this.isRegistered = "2";
      } else {
        this.isRegistered = "1";
      }
    },
    handleblur() {
      if (this.register.password === "") {
        this.line2 = "line";
        this.class2 = "step";
      } else {
        this.line2 = "line lined";
        this.class2 = "step steped";
      }
    },
    Find() {
      if (this.findForm.phone === "") {
        this.$message({
          message: "请输入手机号或用户名",
        });
        return;
      }
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      if (!reg.test(this.findForm.phone)) {
        this.$message({
          message: "手机号码格式错误",
        });
        return;
      }
      if (this.findForm.code === "") {
        this.$message({
          message: "请输入验证码",
        });
        return;
      }
      this.findPassword = false;
    },
    Nouse() {
      this.nouse = false;
    },
    FindSet() {
      if (this.setNew.code === "") {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }

      this.findStep = "2";
      this.line2 = "line lined";
      this.class2 = "step steped";
    },
    FindConfirm() {
      if (this.setNew.password === "") {
        this.$message({
          message: "请输入密码",
          type: "warning",
        });
        return;
      }
      if (this.setNew.verify === "") {
        this.$message({
          message: "请再次输入密码",
        });
        return;
      }
      if (this.setNew.password != this.setNew.verify) {
        this.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return;
      }
      this.findStep = "3";
      this.line2 = "line lined";
      this.class2 = "step steped";
      this.line3 = "line lined";
      this.class3 = "step steped";
    },
  },
};
</script>

<style lang="scss" scoped>
.login2 {
  background: #ffffff !important;
}
.login {
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  min-height: 768px;
  background: #f0f4f7;
  .loginTop {
    // box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 999;
    flex-shrink: 0;
    .loginLogo {
      display: flex;
      align-items: center;
      height: 80px;
      position: relative;
      img {
        // width: 180px;
        // margin-right: 30px;
        height: 68px;
        width: auto;
      }
      span {
        font-size: 18px;
        color: $fontColor;
      }
      .loginImgBox {
        // width: 180px;
        height: 56px;
        align-items: center;
        display: flex;
        margin-left: -50px;
        margin-right: 20px;
        cursor: pointer;
        img {
          height: 63px;
        }
        .register {
          display: inline-block;
          height: 42px;
          // width: 100px;
          line-height: 100%;
          padding: 10px 0 10px 20px;
          margin-left: 20px;
          border-left: 1px solid #a8afbe;
          font-size: 24px;

          font-weight: bold;
        }
      }
      .rightBox {
        position: absolute;
        right: 0;
        height: 20px;
        display: flex;
        align-items: center;

        .brackIndex {
          margin-left: 20px;
          padding-left: 20px;
          display: inline-block;
          border-left: 1px solid #a8afbe;
          color: #606266;
          cursor: pointer;
          &:hover {
            color: #f77b0b;
          }
        }
        .loginText {
          color: #606266;
          cursor: pointer;
          &:hover {
            color: #f77b0b;
          }
        }
      }
    }
  }
  @media screen and (max-width: 2000px) {
    .loginCent2 {
      background: url("../../assets/images/indexBg.png") no-repeat !important;
      background-size: 100% 100% !important;
      flex-grow: 1 !important;
      display: flex !important;
      align-items: center !important;
    }
  }

  @media screen and (min-width: 2000px) {
    .loginCent2 {
      background: url("../../assets/images/indexBgBig.png") no-repeat !important;
      background-size: 100% 100% !important;
      flex-grow: 1 !important;
      display: flex !important;
      align-items: center !important;
      min-width: 2000px !important;
      // padding: 0 auto !important;
    }
  }
  .loginCent {
    background: url("../../assets/images/indexBg.png") no-repeat;
    flex-grow: 1;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .loginBox {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .conTitle {
        position: absolute;
        top: 0;
        left: 0;
        .bigTitle {
          color: #56657b;
          font-size: 34px;
          font-weight: bold;
        }
        .smallTitle {
          color: #56657b;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
    .leftImg {
      width: 50%;
      max-width: 760px;
      height: 620px;
      text-align: right;
      img {
        display: inline-block;
        height: 100%;
      }
    }
    .loginForm {
      width: 35%;
      max-width: 573px;
      min-width: 480px;
      background: #ffffff;
      box-shadow: 0px 15px 14px 2px rgba(162, 87, 20, 0.15);
      border-radius: 8px;
      position: relative;
      left: 100px;
      .loginType {
        padding: 0 100px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        .selected {
          color: #f77b0b;
          font-weight: bold;
        }
        .noselect {
          color: #333333;
          font-weight: normal;
        }
        .account {
          font-size: 20px;

          cursor: pointer;
        }
        .code {
          font-size: 20px;

          cursor: pointer;
        }
      }
      .loginTit {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        width: 100%;
        justify-content: center;
        margin: 50px 0 50px;
        // &:before {
        //   content: '';
        //   height: 2px;
        //   width: 98px;
        //   display: block;
        //   background: url("../../assets/images/dzuo.png") no-repeat;
        //   margin-right: 27px;
        // }
        // &:after {
        //   content: '';
        //   height: 2px;
        //   width: 98px;
        //   display: block;
        //   background: url("../../assets/images/dyou.png") no-repeat;
        //   margin-left: 27px;
        // }
      }
      .noLogin {
        color: #333333;
        font-size: 18px;
        margin: 0 0 30px 0;
        height: 30px;
        padding: 0 80px;
        align-items: center;
        display: flex;
        justify-content: space-between;
        >>> .el-checkbox__label {
          font-size: 16px;
          color: #333333;
          font-weight: 400;
        }
        span {
          cursor: pointer;
          font-size: 16px;
          // text-decoration: underline;
          color: #606266;
          &:nth-child(3) {
            color: #f77b0b;
          }
          &:hover {
            color: #f77b0b;
          }
        }
      }
      .loginFormBox {
        padding: 0 60px;
        .inputBox {
          position: relative;
          display: flex;
          justify-content: space-between;
          label {
            color: $fontColor;
            font-size: 18px;
            font-weight: 500;
          }
          >>> .el-input__inner {
            height: 64px;
            border: none;
            border: 1px solid #eeeeee;
            border-radius: 4px;
            font-size: 20px;
            color: #666666;
            padding-left: 15px;
            &:focus {
              border: 1px solid #f77b0b;
            }
          }

          &:nth-child(2) {
            margin: 50px 0 40px 0;
          }
          .codeBtn {
            width: 135px;
            margin-left: 20px;
            height: 62px;
            border-radius: 4px;
            border: 1px solid #f77b0b;
            color: #f77b0b;
            display: block;
            line-height: 62px;
            text-align: center;
            // position: absolute;
            // right: 0;
            // bottom: 10px;
            cursor: pointer;
          }
          .codeCount {
            color: #f77b0b;
          }
        }

        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 100%;
          background: #f77b0b;
          box-shadow: 0px 7px 11px 4px rgba(236, 235, 235, 0.79);
          border-radius: 4px;
          height: 60px;
          line-height: 60px;

          text-align: center;
          font-size: 20px;
          color: #ffffff;
          margin-bottom: 30px;
          cursor: pointer;
        }
      }
      .loginProtocol {
        padding: 0 60px;
        display: flex;
        align-items: center;
        height: 80px;
        line-height: 80px;
        border-top: 1px solid #eeeeee;
        span {
          margin-left: 10px;
        }
        span:nth-child(3) {
          color: #426bea;
          cursor: pointer;
        }
      }
      >>> .el-checkbox__inner {
        width: 20px;
        height: 20px;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
  @media screen and (max-width: 2000px) {
    .registerCent2 {
      background: url("../../assets/images/indexBg.png") no-repeat !important;
      background-size: 100% 100% !important;
      flex-grow: 1 !important;
      display: flex !important;
      align-items: center !important;
    }
  }

  @media screen and (min-width: 2000px) {
    .registerCent2 {
      width: 100%;
      background: url("../../assets/images/indexBgBig.png") no-repeat !important;
      background-size: 100% 100% !important;
      flex-grow: 1 !important;
      display: flex !important;
      align-items: center !important;
      min-width: 2000px !important;
      padding: 0 auto !important;
    }
  }

  @media screen and (max-width: 2000px) {
    .registerCent {
      background: url("../../assets/images/indexBg2.png") no-repeat;
      background-size: cover;
      flex-grow: 1;
      display: flex;
      align-items: center;

      .loginBox {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .conTitle {
          position: absolute;
          top: 0;
          left: 0;
          .bigTitle {
            color: #56657b;
            font-size: 34px;
            font-weight: bold;
          }
          .smallTitle {
            color: #56657b;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
      .leftImg {
        width: 50%;
        max-width: 760px;
        height: 620px;
        text-align: right;
        img {
          display: inline-block;
          height: 100%;
        }
      }
      .loginForm {
        width: 80%;
        min-width: 573px;
        background: #ffffff;
        box-shadow: 0px 7px 11px 4px rgba(235, 231, 231, 0.27);
        border-radius: 8px;
        position: relative;

        // left: 100px;
        .loginType {
          padding: 0 100px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 60px;
          .selected {
            color: #f77b0b;
            font-weight: bold;
          }
          .noselect {
            color: #333333;
            font-weight: normal;
          }
          .account {
            font-size: 20px;

            cursor: pointer;
          }
          .code {
            font-size: 20px;

            cursor: pointer;
          }
        }
        .findPassword {
          display: flex;
          justify-content: center;
          padding: 0 20%;
          margin: 50px 0;
          .icon {
            font-size: 30px;
            color: #477ce5;
          }
          .content {
            .text {
              font-size: 18px;

              font-weight: bold;
              color: #333333;
              height: 30px;
              line-height: 30px;
              margin-top: 7px;
              margin-left: 10px;
            }
          }
        }
        .loginTit {
          height: 50px;
          display: flex;
          // align-items: center;
          // font-size: 24px;
          // font-weight: bold;
          // color: #333333;
          width: 100%;
          justify-content: space-between;
          margin: 50px 0 60px;
          padding: 0 100px;
          .step {
            // width: 15%;
            .number {
              display: inline-block;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              border: 1px solid #999999;
              font-size: 20px;

              text-align: center;
              line-height: 30px;
              color: #999999;
            }
            .text {
              height: 30px;
              line-height: 30px;
              font-size: 20px;
              margin-left: 10px;
              color: #999999;
            }
          }
          .steped {
            .number {
              border: 1px solid #f77b0b !important;
              color: #ffffff !important;
              background-color: #f77b0b;
            }
            .text {
              color: #f77b0b;
              font-weight: bold;
            }
          }
          .line {
            width: 25%;
            height: 17px;
            margin: 0 15px;
            border-bottom: 1px dashed #999999;
          }
          .lined {
            border-bottom: 1px dashed #f77b0b !important;
          }
        }
        .regSuccess {
          text-align: center;

          margin-bottom: 50px;
          width: 100%;
          .icon {
            font-size: 50px;
            color: #00aa5b;
            margin-top: -13px;
          }

          .text {
            font-size: 18px;

            font-weight: 600;
            color: #333333;
          }
          .toLogin {
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #f77b0b;
            margin-top: 30px;
            cursor: pointer;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin: 20px 0 60px 0;
          height: 30px;
          padding: 0 80px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            // text-decoration: underline;
            color: #606266;
            &:nth-child(3) {
              color: #f77b0b;
            }
            &:hover {
              color: #f77b0b;
            }
          }
        }
        .loginFormBox {
          padding: 0 29%;

          .inputBox {
            display: flex;
            justify-content: space-between;
            position: relative;
            margin-bottom: 20px;
            .massage {
              width: 480px;
              padding: 25px;
              margin-left: 60px;

              background: rgba(247, 123, 11, 0.1);
              .title {
                font-size: 16px;

                font-weight: bold;
                color: #606266;
                margin: 5px 0;
              }
              .item {
                font-size: 14px;
                margin: 15px 0;
                color: #606266;
                line-height: 16px;
              }
            }
            .yesuse {
              display: inline-block;
              width: 480px;
              height: 64px;
              display: flex;
              justify-content: left;
              line-height: 64px;
              font-size: 16px;

              font-weight: 400;

              .phone {
                color: #606266;
              }
              .alter {
                color: #ff4747;
                cursor: pointer;
                margin-left: 20px;
              }
            }
            .tip {
              margin-bottom: 20px;
              padding-bottom: 5px;
              border-bottom: 1px solid #f77b0b;
              span {
                font-size: 16px;

                color: #333333;
              }
              .phone {
                color: #ff4747;
              }
            }
            label {
              color: #333333;
              font-size: 18px;
              font-weight: 400;
              width: 100px;
              height: 64px;
              line-height: 64px;
              text-align: right;
              margin-right: 20px;
            }
            >>> .el-input__inner {
              height: 64px;
              border: none;
              border: 1px solid #eeeeee;
              border-radius: 4px;
              font-size: 20px;
              color: #666666;
              padding-left: 15px;
              &:focus {
                border: 1px solid #f77b0b;
              }
            }
            // &:nth-child(2) {
            //   margin: 60px 0 20px 0;
            // }
            .codeBtn {
              width: 200px;
              margin-left: 20px;
              height: 62px;
              font-size: 16px;
              border-radius: 4px;
              border: 1px solid #f77b0b;
              color: #f77b0b;
              display: block;
              line-height: 62px;
              text-align: center;
              // position: absolute;
              // right: 0;
              // bottom: 10px;
              cursor: pointer;
            }
            .codeCount {
              color: #f77b0b;
            }
          }

          .registered {
            justify-content: flex-end;
          }
          .loginBtn {
            width: 25%;
            margin: 40px auto 60px;
            background: #f77b0b;
            box-shadow: 0px 7px 11px 4px rgba(236, 235, 235, 0.79);
            border-radius: 4px;
            height: 60px;
            line-height: 60px;

            text-align: center;
            font-size: 20px;
            color: #ffffff;
            margin-bottom: 50px;
            cursor: pointer;
          }
        }
        .loginProtocol {
          padding: 0 60px;
          display: flex;
          align-items: center;
          height: 80px;
          line-height: 80px;
          border-top: 1px solid #eeeeee;
          span {
            margin-left: 10px;
          }
          span:nth-child(3) {
            color: #426bea;
            cursor: pointer;
          }
        }
        >>> .el-checkbox__inner {
          width: 20px;
          height: 20px;
          &:after {
            height: 10px;
            left: 7px;
            width: 4px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 2000px) {
    .registerCent {
      background: url("../../assets/images/indexBg2.png") no-repeat;
      background-size: 100% 100%;
      flex-grow: 1;
      display: flex;
      align-items: center;
      min-width: 2000px;
      margin: 0 auto;

      .loginBox {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .conTitle {
          position: absolute;
          top: 0;
          left: 0;
          .bigTitle {
            color: #56657b;
            font-size: 34px;
            font-weight: bold;
          }
          .smallTitle {
            color: #56657b;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
      .leftImg {
        width: 50%;
        max-width: 760px;
        height: 620px;
        text-align: right;
        img {
          display: inline-block;
          height: 100%;
        }
      }
      .loginForm {
        width: 80%;
        min-width: 573px;
        background: #ffffff;
        box-shadow: 0px 7px 11px 4px rgba(235, 231, 231, 0.27);
        border-radius: 8px;
        position: relative;

        // left: 100px;
        .loginType {
          padding: 0 100px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 60px;
          .selected {
            color: #f77b0b;
            font-weight: bold;
          }
          .noselect {
            color: #333333;
            font-weight: normal;
          }
          .account {
            font-size: 20px;

            cursor: pointer;
          }
          .code {
            font-size: 20px;

            cursor: pointer;
          }
        }
        .findPassword {
          display: flex;
          justify-content: left;
          padding: 0 20%;
          margin: 50px 0;
          .icon {
            font-size: 30px;
            color: #477ce5;
          }
          .content {
            .text {
              font-size: 18px;

              font-weight: bold;
              color: #333333;
              height: 30px;
              line-height: 30px;
              margin-top: 7px;
              margin-left: 10px;
            }
          }
        }
        .loginTit {
          height: 50px;
          display: flex;
          // align-items: center;
          // font-size: 24px;
          // font-weight: bold;
          // color: #333333;
          width: 100%;
          justify-content: space-between;
          margin: 50px 0 60px;
          padding: 0 100px;
          .step {
            // width: 15%;
            .number {
              display: inline-block;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              border: 1px solid #999999;
              font-size: 20px;

              text-align: center;
              line-height: 30px;
              color: #999999;
            }
            .text {
              height: 30px;
              line-height: 30px;
              font-size: 20px;
              margin-left: 10px;
              color: #999999;
            }
          }
          .steped {
            .number {
              border: 1px solid #f77b0b !important;
              color: #ffffff !important;
              background-color: #f77b0b;
            }
            .text {
              color: #f77b0b;
              font-weight: bold;
            }
          }
          .line {
            width: 25%;
            height: 17px;
            margin: 0 15px;
            border-bottom: 1px dashed #999999;
          }
          .lined {
            border-bottom: 1px dashed #f77b0b !important;
          }
        }
        .regSuccess {
          text-align: center;
          margin-bottom: 50px;
          width: 100%;
          .icon {
            font-size: 50px;
            color: #00aa5b;
            margin-top: -13px;
          }

          .text {
            font-size: 18px;

            font-weight: 600;
            color: #333333;
          }
          .toLogin {
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #f77b0b;
            margin-top: 30px;
            cursor: pointer;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin: 20px 0 60px 0;
          height: 30px;
          padding: 0 80px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            // text-decoration: underline;
            color: #606266;
            &:nth-child(3) {
              color: #f77b0b;
            }
            &:hover {
              color: #f77b0b;
            }
          }
        }
        .loginFormBox {
          padding: 0 29%;

          .inputBox {
            display: flex;
            justify-content: space-between;
            position: relative;
            margin-bottom: 20px;
            .massage {
              width: 480px;
              padding: 25px;
              margin-left: 60px;

              background: rgba(247, 123, 11, 0.1);
              .title {
                font-size: 16px;

                font-weight: bold;
                color: #606266;
                margin: 5px 0;
              }
              .item {
                font-size: 14px;
                margin: 15px 0;
                color: #606266;
                line-height: 16px;
              }
            }
            .yesuse {
              display: inline-block;
              width: 480px;
              height: 64px;
              display: flex;
              justify-content: left;
              line-height: 64px;
              font-size: 16px;

              font-weight: 400;

              .phone {
                color: #606266;
              }
              .alter {
                color: #ff4747;
                cursor: pointer;
                margin-left: 20px;
              }
            }
            .tip {
              margin-bottom: 20px;
              padding-bottom: 5px;
              border-bottom: 1px solid #f77b0b;
              span {
                font-size: 16px;

                color: #333333;
              }
              .phone {
                color: #ff4747;
              }
            }
            label {
              color: #333333;
              font-size: 18px;
              font-weight: 400;
              width: 100px;
              height: 64px;
              line-height: 64px;
              text-align: right;
              margin-right: 20px;
            }
            >>> .el-input__inner {
              height: 64px;
              border: none;
              border: 1px solid #eeeeee;
              border-radius: 4px;
              font-size: 20px;
              color: #666666;
              padding-left: 15px;
              &:focus {
                border: 1px solid #f77b0b;
              }
            }
            // &:nth-child(2) {
            //   margin: 60px 0 20px 0;
            // }
            .codeBtn {
              width: 200px;
              margin-left: 20px;
              height: 62px;
              font-size: 16px;
              border-radius: 4px;
              border: 1px solid #f77b0b;
              color: #f77b0b;
              display: block;
              line-height: 62px;
              text-align: center;
              // position: absolute;
              // right: 0;
              // bottom: 10px;
              cursor: pointer;
            }
            .codeCount {
              color: #f77b0b;
            }
          }

          .registered {
            justify-content: flex-end;
          }
          .loginBtn {
            width: 25%;
            margin: 40px auto 60px;
            background: #f77b0b;
            box-shadow: 0px 7px 11px 4px rgba(236, 235, 235, 0.79);
            border-radius: 4px;
            height: 60px;
            line-height: 60px;

            text-align: center;
            font-size: 20px;
            color: #ffffff;
            margin-bottom: 50px;
            cursor: pointer;
          }
        }
        .loginProtocol {
          padding: 0 60px;
          display: flex;
          align-items: center;
          height: 80px;
          line-height: 80px;
          border-top: 1px solid #eeeeee;
          span {
            margin-left: 10px;
          }
          span:nth-child(3) {
            color: #426bea;
            cursor: pointer;
          }
        }
        >>> .el-checkbox__inner {
          width: 20px;
          height: 20px;
          &:after {
            height: 10px;
            left: 7px;
            width: 4px;
          }
        }
      }
    }
  }

  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
.logincode {
  width: 128px;
  height: 52px;

  padding: 0;
  border-radius: 4px;
  border: none;
}
.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 385px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.iptHeight {
  height: 54px !important;
  input {
    height: 54px !important;
  }
  span {
    display: flex;
    align-items: center;
  }
  .input-icon {
    width: 20px;
    height: 20px;
  }
}
.footText2 {
  background: #ffffff;
}
.footText {
  font-size: 14px;
  color: #333333;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  // margin-bottom: 20px;
}
.show-pwd {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 20px;

  cursor: pointer;
  user-select: none;
}
>>> .el-form-item__label {
  font-size: 16px;
  height: 64px !important;
  line-height: 64px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue